import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  ANSWER_FEATURE_KEY,
  AnswerState,
  answerAdapter,
} from './answer.reducer';

export const selectAnswerState =
  createFeatureSelector<AnswerState>(ANSWER_FEATURE_KEY);

const { selectAll } = answerAdapter.getSelectors();

export const selectAllAnswers = createSelector(
  selectAnswerState,
  (state: AnswerState) => selectAll(state),
);
